export const INVALID_TYPE_MESSAGE =
  'File type not supported.\nPlease upload a PDF, JPG, PNG, CSV, WebP, GIF, or BMP file.';
export const INVALID_SIZE_MESSAGE =
  'File size exceeds the 10MB limit.\nPlease compress your file or try uploading a smaller version.';

export const SUPPORTED_IMAGE_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/gif',
  'image/bmp',
];
export const SUPPORTED_IMAGE_EXTENSIONS = [
  '.jpg',
  '.jpeg',
  '.png',
  '.webp',
  '.gif',
  '.bmp',
];
